/**
 * Check if only one function returns a value greater than 0.
 * @param {Function} func1, func2, func3 - Functions that return a value.
 * @return {Boolean} True if only one function returns a value greater than 0, False otherwise.
 */
export function checkSinglePositive(a: number, b: number, c: number): boolean {
  const values = [a, b, c];
  return values.filter(val => val > 0).length === 1;
}
